<template>
    <div class="payment-table" id="payment-table">
        <el-table
            :data="datas"
            style="width: 100%"
            class="row-click ah-el-data-table"
            :default-sort="sortSetting"
            :row-class-name="getRowClass"
            empty-text="沒有資料"
            @row-click="handleDataRowClick"
            @sort-change="onSortChange"
            @select="onSelect"
            @select-all="onSelect"
            @selection-change="onSelectChange"
            v-loading="loading"
            ref="table"
        >
            <el-table-column v-if="batchMode" type="selection" :selectable="checkSelectable" width="42" key="checkbox"> </el-table-column>
            <el-table-column prop="payoo" width="105" v-if="showCols.includes('payoo')" key="payoo">
                <!-- eslint-disable-next-line vue/no-unused-vars -->
                <template slot="header" slot-scope="scope">
                    <span @click="onTogglePjCustomNumber">
                        {{ showPjCustomNumber ? "自訂專案編號" : "單號" }}
                    </span>
                </template>
                <template slot-scope="scope">
                    <span class="idx">
                        {{ showPjCustomNumber ? scope.row.customnumber || "--" : scope.row.payoo }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="狀態" width="120" v-if="showCols.includes('status')" key="status">
                <template slot-scope="scope">
                    <div v-if="scope.row.deleted">
                        <div style="opacity: 0.3">已作廢</div>
                    </div>
                    <div v-else>
                        <payment-status-label
                            :status-num="scope.row.sigN_STS"
                            :isTempSaved="scope.row.sigN_STS == 5 && scope.row.a02_ISTEMP"
                            :isPayInFuture="scope.row.sigN_STS == 2 && isDateInFuture(scope.row.paY_DAT)"
                        ></payment-status-label>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="nam" label="請款摘要" v-if="showCols.includes('nam')" key="nam" min-width="250">
                <template slot-scope="scope">
                    <div :style="{ opacity: scope.row.deleted ? 0.3 : 'unset' }">
                        <span class="type-tag">
                            {{ getPaymentType(scope.row.typ) }}
                            <span v-if="scope.row.tranServiceFeeStatement">[勞務單轉送]</span>
                        </span>
                        <span class="type-tag primary" v-if="scope.row.toBeAddFile">待補單據</span>
                        <span class="strong">{{ scope.row.nam }}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="pdat" label="預計付款日" width="115" key="pdat" :sortable="nonCustomSort ? '' : 'custom'" v-if="showCols.includes('pdat')">
                <template slot-scope="scope">
                    <div :style="{ opacity: scope.row.deleted ? 0.3 : 'unset' }">
                        <div v-if="scope.row.pdat && scope.row.pdat > 0">
                            {{ scope.row.pdat | dateFormater("YYYY-MM-dd") }}
                        </div>
                        <div v-else>(無)</div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="paY_DAT" label="實際付款日" width="115" key="paY_DAT" v-if="showCols.includes('paY_DAT')" :show-overflow-tooltip="true" :sortable="nonCustomSort ? '' : 'custom'">
                <template slot-scope="scope">
                    <div v-if="scope.row.paY_DAT && scope.row.paY_DAT > 0">
                        {{ scope.row.paY_DAT | dateFormater("YYYY-MM-dd") }}
                    </div>
                    <div v-else>(無)</div>
                </template>
            </el-table-column>
            <el-table-column prop="creator" label="申請人" width="85" key="creator" v-if="showCols.includes('creator')" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <div :style="{ opacity: scope.row.deleted ? 0.3 : 'unset' }">
                        {{ scope.row.creator }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="paY_WAY" label="實際付款方式" width="100" key="paY_WAY" v-if="showCols.includes('paY_WAY')" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <span v-if="scope.row.paY_WAY == 1">零用現金</span>
                    <span v-else-if="scope.row.paY_WAY == 2">銀行轉帳</span>
                    <span v-else></span>
                </template>
            </el-table-column>
            <el-table-column prop="paY_BNK" label="實際付款帳戶" width="100" key="paY_BNK" v-if="showCols.includes('paY_BNK')" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    {{ getBankAccountName(scope.row.paY_BNK_SNO) }}
                </template>
            </el-table-column>
            <el-table-column label="進度" class="progress" v-if="showCols.includes('progress')" key="progress" width="100">
                <template slot-scope="scope">
                    <ah-audit-progress type="payment" :data="scope.row.audits" :statusCode="scope.row.sigN_STS"></ah-audit-progress>
                </template>
            </el-table-column>
            <el-table-column prop="amt" label="含稅金額" v-if="showCols.includes('amt')" key="amt" align="right" width="160" :sortable="nonCustomSort ? '' : 'custom'">
                <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" content="零用現金" placement="top">
                        <i v-if="isPayByCash(scope.row)" class="el-icon-money" style="opacity: 0.6; margin-right: 8px"></i>
                    </el-tooltip>
                    <Money :v="scope.row.amt" :precision="scope.row.cny === 'TWD' ? null : 4" />
                    <ahTip v-if="scope.row.cny != 'TWD'">
                        <div>
                            約當台幣：
                            <Money :v="scope.row.paY_CNYRAT ? scope.row.amt * scope.row.paY_CNYRAT : scope.row.amt * getCnyRat(scope.row.cny)" />
                        </div>
                        <div
                            style="
                                opacity: 0.8;
                                font-size: 10pt;
                                margin-top: 5px;
                            "
                        >
                            匯率：{{ scope.row.paY_CNYRAT ? scope.row.paY_CNYRAT : getCnyRat(scope.row.cny) + " (即時)" }}
                        </div>
                    </ahTip>
                    <span class="cny">{{ scope.row.cny }}</span>
                </template>
            </el-table-column>
        </el-table>
        <PaymentDetailDialog ref="detailDialog" @close="handleDetailDialogClose" :sno="detailDialogSno" :visible="detailDialogVisible" />
    </div>
</template>
<script>
import { paymentType } from '@/assets/commonData/options';
import ahAuditProgress from '@/components/ui/ahAuditProgress.vue';
import PaymentStatusLabel from './PaymentStatusLabel.vue';
import PaymentDetailDialog from './PaymentDetailDialog.vue';

export default {
    name: 'PaymentTable',
    props: {
        datas: {
            type: Array,
            default: () => [],
        },
        loading: {
            type: Boolean,
            default: false,
        },
        batchMode: {
            type: Boolean,
            default: false,
        },
        isSortByDate: {
            type: Boolean,
            default: true,
        },
        showCols: {
            type: Array,
            default: () => ['payoo', 'status', 'nam', 'pdat', 'creator', 'progress', 'amt'],
        },
        nonCustomSort: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        ahAuditProgress,
        PaymentDetailDialog,
        PaymentStatusLabel,
    },
    data() {
        return {
            detailDialogVisible: false,
            detailDialogSno: null,
            lastDetailDialogSno: null,
            today: new Date(),

            showPjCustomNumber: false,
        };
    },
    created() {},
    computed: {
        sortSetting() {
            if (this.isSortByDate) {
                return { prop: 'crT_DAT', order: 'descending' };
            }
            return { prop: null, order: null };
        },
        selection() {
            return this.$refs.table.selection;
        },
    },
    methods: {
        isPayByCash(data) {
            // 狀態為：待確認付款、完成，使用 pay_way 判斷（因為已確定付款方式）
            if (data.sigN_STS === 2 || data.sigN_STS === 3) {
                if (data.paY_WAY === 1) return true;
            }
            // 其他狀態，使用 useR_PAY_WAY 判斷
            else if (data.useR_PAY_WAY === 1) return true;
            return false;
        },
        isDateInFuture(datetime) {
            return new Date() < new Date(datetime);
        },
        checkSelectable(row) {
            // if (new Date(row.paY_DAT) > this.today) {
            //     return false;
            // }
            return true;
        },
        handleDataRowClick(data) {
            this.detailDialogVisible = true;
            this.detailDialogSno = data.sno;
            this.lastDetailDialogSno = null;
            document.body.classList.add('detail-opened');
        },

        handleDetailDialogClose(refresh) {
            this.lastDetailDialogSno = this.detailDialogSno;
            this.detailDialogVisible = false;
            this.detailDialogSno = null;
            this.$emit('detailClose', refresh);
            document.body.classList.remove('detail-opened');
        },
        onSortChange(event) {
            this.$emit('sort-change', event);
        },
        getRowClass({ row }) {
            if (row.sno === this.detailDialogSno) {
                return 'curr-detail-dialog-target';
            }
            if (row.sno === this.lastDetailDialogSno) {
                return 'last-detail-dialog-target';
            }
            if (row.sigN_STS === 3) return 'finish';
            return '';
        },
        getPaymentType(type) {
            const item = paymentType.find((x) => x.key === type);
            if (item) return item.value;
            return '';
        },
        getNowAuditing(list) {
            if (list) {
                for (let i = 0; i < list.length; i += 1) {
                    if (list[i].fin === 0) {
                        return i;
                    }
                }
            }
            return 0;
        },
        getCnyRat(cny) {
            const cnyOption = this.$store.getters['cny/cnyOptions'].find((x) => x.cny === cny);
            if (cnyOption) return cnyOption.rat;
            return 1;
        },
        getBankAccountName(sno) {
            const bankAccount = this.$store.getters['bankAccount/bankAccountOptions'].find((x) => x.sno === sno);
            if (bankAccount) return bankAccount.tpc;
            return '-';
        },
        removeHighlight() {
            this.lastDetailDialogSno = null;
        },

        onTogglePjCustomNumber() {
            this.showPjCustomNumber = !this.showPjCustomNumber;
        },
        onSelect(selection, row) {
            this.$emit('select', selection, row);
        },
        onSelectChange(selection) {
            this.$emit('select-change', selection);
        },
        toggleRowSelection(row, selected) {
            this.$refs.table.toggleRowSelection(row, selected);
        },
        selectRowBySno(sno, selected) {
            this.$refs.table.data.forEach((row) => {
                if (row.sno === sno) {
                    this.$refs.table.toggleRowSelection(row, selected);
                }
            });
        },
    },
};
</script>
